import { cn } from "@/lib/utils";

/** The single Voice Studio logo mark, the purple brand glyph as an SVG, so it
 * stays sharp at any size. Rendered with object-contain (no circular crop) so
 * the full mark shows cleanly on any background. */
export function Logo({ size = 36, className }: { size?: number; className?: string }) {
  return (
    // eslint-disable-next-line @next/next/no-img-element
    <img
      src="/voice-studio-logo.svg"
      alt="Voice Studio"
      width={size}
      height={size}
      style={{ width: size, height: size }}
      className={cn("object-contain", className)}
    />
  );
}

/** The full "voice studio" lockup. The source art ships with an opaque white
 * backing rectangle; that is stripped from the copy in public/ so the mark sits
 * on a dark sidebar the same way it sits on a light one. Height-constrained so
 * its intrinsic aspect drives the width; all balance/spacing is handled by the
 * surrounding container. */
export function Wordmark({ height = 46, className }: { height?: number; className?: string }) {
  return (
    // eslint-disable-next-line @next/next/no-img-element
    <img
      src="/voice-studio-wordmark.svg"
      alt="Voice Studio"
      style={{ height }}
      className={cn("w-auto object-contain", className)}
    />
  );
}
